export interface SizeOrderItem {
  sku: string;
  productTitle?: string | null;
  title?: string | null;
  variantTitle?: string | null;
}

const marker = "サイズオーダー";

export function sizeOrderProductName(item: SizeOrderItem): string {
  const name = item.productTitle?.trim();
  if (name) return name;
  // Shopify line.name can include the variant; the variant alone is not a product name.
  const title = item.title?.trim() ?? "";
  const variantSuffix = item.variantTitle?.trim() ? ` - ${item.variantTitle.trim()}` : "";
  return variantSuffix && title.endsWith(variantSuffix) ? title.slice(0, -variantSuffix.length).trim() : title;
}

export const isExpressSizeOrderItem = (item: SizeOrderItem): boolean => sizeOrderProductName(item).includes("特急");
export function hasSizeOrderName(item: SizeOrderItem): boolean {
  const name = sizeOrderProductName(item);
  return name.includes(marker) && !name.includes("特急");
}
export function isSizeOrderItem(item: SizeOrderItem): boolean {
  const name = sizeOrderProductName(item);
  return !name.includes("特急") && (/(?:98|99)$/.test(item.sku.trim()) || name.includes(marker));
}

export function sizeOrderNameSuffix(item: SizeOrderItem): string {
  return sizeOrderProductName(item).replaceAll(marker, "").replace(/[（(【\[]\s*[）)】\]]/gu, "")
    .replace(/^[\s・:：/／_\-－]+|[\s・:：/／_\-－]+$/gu, "").replace(/\s+/gu, " ") || "商品";
}
